import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** Domain layout: one guard for the list and the detail screen. */
export const Route = createFileRoute("/_authenticated/_support/task-center")({
  beforeLoad: ({ context }) => guardRoute(context.me, "task-center"),
  component: Outlet,
});
